import { MenuItemsCalloutInfo } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

export const shouldShowHalfCardTrigger = (calloutInfo?: MenuItemsCalloutInfo) => {
    if (isEmpty(calloutInfo) || isEmpty(calloutInfo.half_card_trigger_text) || isEmpty(calloutInfo.half_card_info)) {
        return false;
    }

    if (
        isEmpty(calloutInfo.half_card_info?.image_url) &&
        isEmpty(calloutInfo.half_card_info?.title) &&
        isEmpty(calloutInfo.half_card_info?.description_list)
    ) {
        return false;
    }

    return true;
};
